import { FC, useEffect } from "react";
import { Box, CircularProgress } from "@material-ui/core";
import { useNav } from "hooks/useNav";
import { useShiftPageStyles } from "./styles";
import ShiftPageHead from "./ShiftRecordContent/ShiftRecordHead";
import { useDispatch } from "react-redux";
import { getRecordAction } from "actions/shiftTrackerActions";
import ShiftRecordStats from "./ShiftRecordContent/ShiftRecordStats";
import ShiftRecordContainers from "./ShiftRecordContent/ShiftRecordContainers";
import ShiftRecordTableFooter from "./ShiftRecordContent/ShiftRecordTableFooter";
import { useTypeSelectors } from "hooks/useTypeSelectors";

const ShiftRecordPage: FC = () => {
  const classes = useShiftPageStyles();
  const dispatch = useDispatch();
  const { id } = useNav().pageParams;
  const currentReportId = useTypeSelectors((state) => state.dasBoard.currentReportId);
  const isThisReport = Number(id) === currentReportId;

  useEffect(() => {
    if (id) dispatch(getRecordAction(id));
  }, [id, dispatch]);

  if (!id) return null;

  return (
    <Box className={classes.root}>
      <ShiftPageHead />
      {isThisReport ? (
        <>
          <ShiftRecordStats />
          <Box className={classes.contentBox}>
            <ShiftRecordContainers />
            <ShiftRecordTableFooter />
          </Box>
        </>
      ) : (
        <Box display="flex" justifyContent="center" alignItems="center" p={6}>
          <CircularProgress />
        </Box>
      )}
    </Box>
  );
};

export default ShiftRecordPage;
